import styled from "styled-components";

const Wrapper = styled.div`
  width: 48px;
  height: 48px;
`;

export default Wrapper;
